module.exports = __webpack_public_path__ + "img/yingxiao.6a9055a3.png";